import {
  descriptionUI,
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { OtherTricareAddtlInfo } from '../../components/FormDescriptions/TricareAddtlInfo';
import { blankSchema } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['eligibility--tricare-title'];
const INPUT_LABEL = content['eligibility--tricare-label--other'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    'view:tricareEnrollment': yesNoUI({
      title: INPUT_LABEL,
      enableAnalytics: true,
    }),
    'view:addtlInfo': descriptionUI(OtherTricareAddtlInfo),
  },
  schema: {
    type: 'object',
    required: ['view:tricareEnrollment'],
    properties: {
      'view:tricareEnrollment': yesNoSchema,
      'view:addtlInfo': blankSchema,
    },
  },
};
